import React from "react";
import './Projects.css'
import ProjectSlider from '../assets/components/ProjectSlider.js'
import Biography from '../assets/components/Biography.js'
import Carousel from '../assets/components/Carousel.js'
import projectList from '../assets/projectList.js'
import { Link } from "react-router-dom";

const Projects = (props) => {
  return (
    <div>
      <Biography isMobile={props.isMobile} />
      <div >
        <h1 className="myWork"> PROFESSIONAL WORK </h1>
        <div className="currentPositions">
          <p className="currentPositionText"> LEAD ENGINEER AT <a className="highlightLink" href="https://www.cerise-technology.com/" target="_blank" rel="noreferrer"> CERISE TECHNOLOGY </a></p>
          <p className="currentPositionText"> DESIGNER AT <a className="highlightLink" href="https://www.cerasus-creative-studios.com/" target="_blank" rel="noreferrer"> CERASUS CREATIVE STUDIOS </a></p>
          <p className="currentPositionText"> EDUCATOR AT <a className="highlightLink" href="https://www.future-tech-founders.org/" target="_blank" rel="noreferrer"> FUTURE TECH FOUNDERS </a></p>
        </div>
      </div>
      <div>
        <h1 className="myWork"> TECH PROJECTS </h1>
        <ProjectSlider isMobile={props.isMobile} projectList={projectList} />
      </div>
      <div>
        <h1 className="myWork"> CREATIVE PROJECTS </h1>
        <div className="row">
          <p className="blogSubtitleText"> I love designing and building things - I've written short stories on a few of my projects, including some <a className="projectsHref" href="https://inoodlefactory.com/instantnoodlefactory"> Instant Noodle Factory</a> builds </p>
        </div>
        <div className="buttonRow">
          <Link className="link" to="/blog" >
            <p className="storiesButton"> READ HERE </p>
          </Link>
        </div>
      </div>
      <h1 className="myWork"> PHOTOGRAPHY </h1>
      <div className="row">
        <Carousel />
      </div>
    </div >
  )
}

export default Projects;